module.exports = __webpack_public_path__ + "img/11.5ad56901.webp";